/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { UiService } from '@services/ui/ui.service';
import { AuthService } from '@services/auth/auth.service';
import { Component, OnInit } from '@angular/core';
import { LabelsService } from '@services/labels/labels.service';
import { DeviceService } from '@core/services/device/device.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(
    authService: AuthService,
    labels: LabelsService,
    uiService: UiService,
    deviceService: DeviceService
  ) {
    labels.loadOpenLabels().subscribe();
    authService.addActionAfterLogon(labels.loadLabels());
    uiService.ensureFullscreen();
    uiService.ensureOverlayClosingOnPageChange();
    deviceService.listenConnectionLoss();
  }

  ngOnInit() {}
}
